import { useQuery } from '@pylot-data/hooks/use-query'
import { GET_SHARE_WISHLIST } from '../graphql/getShareWishlistMutation'
import { SharedWishlist } from '@pylot-data/pylotschema'
import { GraphQLError } from '@pylot-data/graphqlFetch'
import type { RequestInit } from '@vercel/fetch'
import type { SWRConfiguration } from 'swr'

export type SharedWishlistResponse = {
    sharedList?: SharedWishlist
    loading: boolean
    error?: GraphQLError
}

const swrSpecs = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false
}

export const useGetSharedWishlist = (
    code: string,
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
): SharedWishlistResponse => {
    const { data, error, isValidating } = useQuery<
        { code: string },
        { getShareWishList: SharedWishlist }
    >(GET_SHARE_WISHLIST, { code }, swrSpecs, fetchOptions)

    return {
        sharedList: data?.data.getShareWishList,
        loading: isValidating,
        error
    }
}
